import script from "./Left_AsideLg.vue?vue&type=script&setup=true&lang=js"
export * from "./Left_AsideLg.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__